var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14109_43198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 8.00008C6.66602 8.3537 6.80649 8.69284 7.05654 8.94289C7.30659 9.19294 7.64573 9.33341 7.99935 9.33341C8.35297 9.33341 8.69211 9.19294 8.94216 8.94289C9.19221 8.69284 9.33268 8.3537 9.33268 8.00008C9.33268 7.64646 9.19221 7.30732 8.94216 7.05727C8.69211 6.80722 8.35297 6.66675 7.99935 6.66675C7.64573 6.66675 7.30659 6.80722 7.05654 7.05727C6.80649 7.30732 6.66602 7.64646 6.66602 8.00008Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 8C12.4 10.6667 10.4 12 8 12C5.6 12 3.6 10.6667 2 8C3.6 5.33333 5.6 4 8 4C10.4 4 12.4 5.33333 14 8Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14109_43198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.62b5d443f187834bf7b36673b9a8cc97.svg";
export { ForwardRef as ReactComponent };